export default {
    blueprint : [
		{
			name: "Script",
			key: ["value"],
			type: "script",
		}
	],
}